import { useState } from "react";
import { Link } from "react-router-dom";
import "../css/contact.css";

const initialForm = {
  name: "",
  email: "",
  message: "",
};

export default function Contact() {
  const [form, setForm] = useState(initialForm);
  const [submitted, setSubmitted] = useState(false);

  function update(field, value) {
    setForm((current) => ({
      ...current,
      [field]: value,
    }));
  }

  function handleSubmit(e) {
    e.preventDefault();
    setSubmitted(true);
  }

  if (submitted) {
    return (
      <main className="contact">
        <section className="contact-success">
          <div className="wrap">
            <div className="success-box">
              <div className="success-mark">✓</div>

              <span className="eyebrow">
                <span className="eyebrow-dot" />
                Message received
              </span>

              <h1>
                Thanks,{" "}
                <span>{form.name.split(" ")[0] || "there"}.</span>
              </h1>

              <p>
                Your message has been received. We'll get back to you
                as soon as possible.
              </p>

              <div className="success-actions">
                <Link to="/quote" className="btn btn-primary">
                  Request a Quote
                </Link>

                <button
                  type="button"
                  className="success-secondary"
                  onClick={() => {
                    setForm(initialForm);
                    setSubmitted(false);
                  }}
                >
                  Send another message
                </button>
              </div>
            </div>
          </div>
        </section>
      </main>
    );
  }

  return (
    <main className="contact">

      {/* HERO */}
      <section className="contact-hero">
        <div className="wrap">

          <div className="contact-hero-top">
            <span className="eyebrow">
              <span className="eyebrow-dot" />
              Contact
            </span>

            <span className="contact-hero-index">
              IGC / 04
            </span>
          </div>

          <h1 className="contact-hero-title">
            Let's talk about
            <br />
            <span>your next print.</span>
          </h1>

          <div className="contact-hero-bottom">
            <p>
              Have a project in mind? Tell us what you're working on
              and we'll help you figure out the right way to bring it
              to print.
            </p>

            <span className="scroll-indicator">↓</span>
          </div>

        </div>
      </section>

      {/* MAIN CONTENT */}
      <section className="contact-main">
        <div className="wrap contact-layout">

          {/* FORM */}
          <div className="contact-form-wrap">

            <div className="contact-section-label">
              <span>01</span>
              Send an enquiry
            </div>

            <form
              className="message-form"
              onSubmit={handleSubmit}
            >

              <div className="form-heading">
                <h2>
                  What can we
                  <br />
                  help you with?
                </h2>

                <p>
                  Fill in the details below and we'll be in touch.
                </p>
              </div>

              <div className="form-fields">

                <label className="field">
                  <span>Name</span>

                  <input
                    type="text"
                    required
                    value={form.name}
                    onChange={(e) =>
                      update("name", e.target.value)
                    }
                    placeholder="Your name"
                  />
                </label>

                <label className="field">
                  <span>Email</span>

                  <input
                    type="email"
                    required
                    value={form.email}
                    onChange={(e) =>
                      update("email", e.target.value)
                    }
                    placeholder="you@company.com"
                  />
                </label>

                <label className="field field-message">
                  <span>Message</span>

                  <textarea
                    required
                    rows={6}
                    value={form.message}
                    onChange={(e) =>
                      update("message", e.target.value)
                    }
                    placeholder="Tell us about your project..."
                  />
                </label>

              </div>

              <div className="form-footer">

                <p>
                  We typically respond within one business day.
                </p>

                <button
                  type="submit"
                  className="form-submit"
                >
                  Send Message
                  <span>↗</span>
                </button>

              </div>

            </form>
          </div>

          {/* CONTACT INFORMATION */}
          <aside className="contact-details">

            <div className="contact-section-label">
              <span>02</span>
              Contact
            </div>

            <div className="contact-details-intro">
              <h2>
                Come by.
                <br />
                Call us.
                <br />
                <span>Let's print.</span>
              </h2>
            </div>

            {/* CONTACT CARDS */}
            <div className="contact-cards">

              {/* ADDRESS */}
              <a
                href="https://www.google.com/maps/search/?api=1&query=CBU+Mall+Igwuruta+Along+Eneka+Road+Port+Harcourt+Rivers+State+Nigeria"                target="_blank"
                rel="noreferrer"
                className="contact-card"
              >
                <div className="contact-card-top">
                  <span className="contact-card-label">
                    Studio
                  </span>

                  <span className="contact-card-icon">
                    ↗
                  </span>
                </div>

                <p>
                  CBU Mall, Igwuruta, <br />
                  Along Eneka Road<br />
                  Port Harcourt, <br />
                  Rivers State, Nigeria
                </p>

                <span className="contact-card-action">
                  Get directions
                </span>
              </a>

              {/* PHONE */}
              <a
                href="tel:+2348037738028"
                className="contact-card"
              >
                <div className="contact-card-top">
                  <span className="contact-card-label">
                    Phone
                  </span>

                  <span className="contact-card-icon">
                    ↗
                  </span>
                </div>

                <p className="contact-card-large">
                  +234 803 773 8028
                </p>

                <span className="contact-card-action">
                  Call us
                </span>
              </a>

              {/* EMAIL */}
              <a
                href="mailto:print@igcpress.ng"
                className="contact-card"
              >
                <div className="contact-card-top">
                  <span className="contact-card-label">
                    Email
                  </span>

                  <span className="contact-card-icon">
                    ↗
                  </span>
                </div>

                <p className="contact-card-large">
                  print@igcpress.ng
                </p>

                <span className="contact-card-action">
                  Send an email
                </span>
              </a>

            </div>

            {/* OPENING HOURS */}
            <div className="contact-hours">

              <div className="contact-card-label">
                Opening hours
              </div>

              <div className="hours-row">
                <span>Mon — Fri</span>
                <span>8:00 AM — 6:00 PM</span>
              </div>

              <div className="hours-row">
                <span>Saturday</span>
                <span>9:00 AM — 2:00 PM</span>
              </div>

              <div className="hours-row">
                <span>Sunday</span>
                <span>Closed</span>
              </div>

            </div>

            {/* QUOTE CTA */}
            <div className="details-footer">

              <div>
                <span>Need a price?</span>

                <strong>
                  Get a quote for your project.
                </strong>
              </div>

              <Link to="/quote">
                Get a quote
                <span>↗</span>
              </Link>

            </div>

          </aside>

        </div>
      </section>

    </main>
  );
}